var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38892 8.38892H7.30162C8.81387 8.38892 10.0397 9.61477 10.0397 11.127V13.4088H11.8651V4.28176H9.58337V2.45635H12.7778C13.2819 2.45635 13.6905 2.86499 13.6905 3.36905V4.90211C14.025 4.52237 14.5138 4.28176 15.0596 4.28176H15.9723V7.93256H15.0596C14.5135 7.93256 14.025 7.69134 13.6905 7.31129V8.84527H14.6032C17.1236 8.84527 19.1667 10.8884 19.1667 13.4088V15.2342H17.3413C17.3413 16.7464 16.1155 17.9723 14.6032 17.9723C13.091 17.9723 11.8651 16.7464 11.8651 15.2342H7.30162C7.30162 16.7464 6.07572 17.9723 4.56351 17.9723C3.0513 17.9723 1.8254 16.7464 1.8254 15.2342H0V2H6.38892V8.38892ZM4.56351 14.3215C4.05944 14.3215 3.65081 14.7301 3.65081 15.2342C3.65081 15.7383 4.05944 16.1469 4.56351 16.1469C5.06758 16.1469 5.47621 15.7383 5.47621 15.2342C5.47621 14.7301 5.06758 14.3215 4.56351 14.3215ZM14.6032 14.3215C14.0992 14.3215 13.6905 14.7301 13.6905 15.2342C13.6905 15.7383 14.0992 16.1469 14.6032 16.1469C15.1073 16.1469 15.5159 15.7383 15.5159 15.2342C15.5159 14.7301 15.1073 14.3215 14.6032 14.3215Z",
    fill: "#E3A500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.423291c33cfed33d12737f2411b73286.svg";
export { ForwardRef as ReactComponent };